import React from "react";
import "./style.css";
import Button from "../CtaButton";
import OurServicesCard from "../our-services-card/OurServicesCard";
import { Link } from "react-router-dom";

const OurServices = ({
  shortHeading,
  buttonText,
  mainHeading,
  description,
  servicesCardsData,
}) => {
  return (
    <>
      <div className="our-services-main-box">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-10 col-md-12">
              <h2 className="low-top-heading">{shortHeading}</h2>
              <p
                className="capital-sub-heading"
                dangerouslySetInnerHTML={{ __html: mainHeading }}
              />
              <p
                className="description-text"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              ></p>
            </div>
          </div>

          <div className="row mt-0">
            {servicesCardsData?.map((card, index) => {
              return (
                <div className="col-md-6 col-lg-4 mt-4" key={index}>
                  {/* {card?.link ? <Link to={card?.link ? card?.link : "#"} target={card?.link ? "_blank" : "_self"} className="text-decoration-none">
                    <OurServicesCard
                      text={card?.title}
                      description={card?.description}
                      icon={card?.icon}
                      techStackIcons={card?.techStackIcons}
                    />
                  </Link> : <OurServicesCard
                    text={card?.title}
                    description={card?.description}
                    icon={card?.icon}
                    techStackIcons={card?.techStackIcons}
                  />} */}
                  {card?.link ? (
                    <Link
                      to={card.link}
                      target="_blank"
                      className="text-decoration-none"
                    >
                      <OurServicesCard
                        text={card.title}
                        description={card.description}
                        icon={card.icon}
                        techStackIcons={card.techStackIcons}
                      />
                    </Link>
                  ) : (
                    <OurServicesCard
                      text={card.title}
                      description={card.description}
                      icon={card.icon}
                      techStackIcons={card.techStackIcons}
                    />
                  )}
                </div>
              );
            })}
            <div className="col-md-6 col-lg-4 mt-4">
              <div className="our-services-cta-box">
                <Link to="/contact-us">
                  {buttonText?.text || buttonText}{" "}
                  <i
                    className={`fa-solid ${document.dir === "rtl"
                      ? "fa-arrow-left-long"
                      : "fa-arrow-right-long"
                      }`}
                    aria-hidden="true"
                  ></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurServices;
